/** CUSTOM INPUT 
function showCustom() {
  var checked_start = document.querySelector('input[name = "template--15638581968981__main-7101218619477-type-selector"]:checked');

  if (checked_start.value == "Custom Name") {
    document.getElementsByClassName("custom-option")[0].style.display = "block";
    $("#product-form-template--15638581968981__main-7101218619477-custom-7").attr('maxlength','12');
  } else {
    document.getElementsByClassName("custom-option")[0].style.display = "none";
  }
}

window.onload = showCustom;
document.getElementById("template--15638581968981__main-7101218619477-type-selector-opt-0").onchange = showCustom; 
document.getElementById("template--15638581968981__main-7101218619477-type-selector-opt-1").onchange = showCustom;
**/


(function() {
  // 1. Instantly hide the hash from the theme's native load scripts
  const hash = window.location.hash;
  if (!hash || hash !== '#guide') return;

  // Temporarily wipe the hash from the URL so the theme thinks it's a normal page load
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  window.location.hash = '';

  // 2. Wait until everything (images, blocks, fonts) is fully rendered and sized
  window.addEventListener('load', function() {
    // Put the hash back in the browser address bar for UX consistency
    history.replaceState(null, null, hash);

    setTimeout(function() {
      const target = document.querySelector(hash);
      if (!target) return;

      // 3. Perfect, calculated single scroll after the page is completely still
      const headerOffset = 20; // Adjust based on your header thickness
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }, 200); // 200ms breathing room after full page load
  });
})();





